import { useFiltersContext } from "../../../../Common/Filters/hooks/useFiltersContext";
import { useChartsData } from "../../../../Common/hooks/useChartsData";
import useLocations from "../../../../Common/Filters/hooks/useLocations";

const useCityCnes = (cityId) => {
    const { data, isLoading } = useLocations(cityId);

    const locations = Array.isArray(data) ? data : [];

    return {
        cityCnes: [...new Set(locations.map((location) => location.co_cnes).filter(Boolean))],
        isLoadingCnes: isLoading
    };
};

export const useCityServices = (queryConfig) => {
    const { filters } = useFiltersContext();
    const { cityCnes, isLoadingCnes } = useCityCnes(
        filters.cidade?.governance_room_client_city_id
    );

    const unit = String(filters.unidade?.value ?? '');
    const hasUnit = unit !== '' && !unit.includes(',');
    const wantsCityUnits = !hasUnit && queryConfig.allCityUnits === true;

    // Sem unidades cadastradas para a cidade, volta para o filtro por residência
    const useCityUnits = wantsCityUnits && cityCnes.length > 0;
    
    const { data, isLoading, isError } = useChartsData(
        {
            key: queryConfig.key,
            url: queryConfig.url,
            enabled: !wantsCityUnits || !isLoadingCnes
        },
        {
            location: useCityUnits ? cityCnes : filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
            city: filters.cidade?.value
        }
    );

    const chartData = data
        ? {
              counterByCity: data?.counterByCity || []
          }
        : {
              counterByCity: []
          };

    return {
        chartData,
        isLoading: isLoading || (wantsCityUnits && isLoadingCnes),
        isError,
        data
    };
};
